/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProjectClient,
    ProjectClientFromJSON,
    ProjectClientFromJSONTyped,
    ProjectClientToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedProjectClientList
 */
export interface PaginatedProjectClientList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectClientList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectClientList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectClientList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ProjectClient>}
     * @memberof PaginatedProjectClientList
     */
    results?: Array<ProjectClient>;
}

export function PaginatedProjectClientListFromJSON(json: any): PaginatedProjectClientList {
    return PaginatedProjectClientListFromJSONTyped(json, false);
}

export function PaginatedProjectClientListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedProjectClientList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ProjectClientFromJSON)),
    };
}

export function PaginatedProjectClientListToJSON(value?: PaginatedProjectClientList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ProjectClientToJSON)),
    };
}

